export default {"src":"/_next/static/media/avanti-logo-white.24e36810.svg","height":31,"width":92,"blurWidth":0,"blurHeight":0};